export const blockIconsPhotoandimageNaturePeopleNew = (
	<span className='material-symbols-outlined'>nature_people</span>
);
